var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("portal", { attrs: { to: "page-loader" } }, [
    _c(
      "div",
      { staticClass: "page-loader-wrapper" },
      [
        _c(
          "transition",
          { attrs: { name: "page-loader" } },
          [
            _vm.show
              ? _c("b-progress", {
                  attrs: {
                    value: _vm.value,
                    max: _vm.max,
                    animated: "",
                    height: "0.2rem"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }